<template>
  <VBlock class="toast">
    <VSpan class="span" :text="text" :color="TextColor.white" :size="14" />
  </VBlock>
</template>

<script>
import VSpan, { TextColor } from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VBlock from '@/presentationals/v2/components/layouts/molecules/VBlock'

export default {
  name: 'VToast',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  components: {
    VSpan,
    VBlock
  },
  data() {
    return {
      TextColor
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.toast {
  width: 100%;
  height: auto;
  padding: 10px 10px 10px;
  box-sizing: border-box;
  background-color: $gray;
  border-radius: 4px;
  opacity: 0.95;

  & .span {
    text-align: center;
  }
}
</style>
